export default __webpack_public_path__ + "static/media/p3.45834b32.png";